
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import * as Papi from '@app/papi';
import { Observable } from 'rxjs';

import { isNil } from 'lodash';

@Injectable()
export class AuthGuard  {

	constructor(private router: Router, private papi: Papi.Service) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		// let currentUser = JSON.parse(localStorage.getItem('currentUser'));

		// console.log('AuthGaurd.canActivate');

		return this.papi.verify().pipe(map((verified: boolean) => {
			if (!verified) {
				// error when verify so redirect to login page with the return url
				return this.errorOut(state);
			}

			// logged in so return true
			return verified;
		}));
	}

	errorOut(state: RouterStateSnapshot) {
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}